// togglePostAssetFullscreenModal.js
'use strict';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import getModalData from '../selector/getModalData.js';
import { REMOVE_OPERATION_DATA, SET_OPERATION_DATA } from '../ActionTypes.js';

const MODAL_ID = 'PostAssetFullscreenModal';

/**
 * Toggle post asset fullscreen preview modal
 * @kind action
 * @param {string} {postId} - post id.
 * @param {string} {clickedAssetId} - asset id.
 * @return {Promise} Action promise.
 */
const togglePostAssetFullscreenModal =
  ({ postId, clickedAssetId } = {}) =>
  async (dispatch, getState) => {
    const isModalOpened =
      getModalData(getState(), MODAL_ID, 'status') === 'display';

    if (isModalOpened) {
      dispatch({
        type: REMOVE_OPERATION_DATA,
        payload: {
          selectPath: ['modal', MODAL_ID],
        },
      });
      return dispatch(
        removeModals({
          ids: [MODAL_ID],
          transitionStatus: 'closing',
        })
      );
    }
    dispatch({
      type: SET_OPERATION_DATA,
      payload: {
        selectPath: ['modal', MODAL_ID],
        data: {
          postId,
          clickedAssetId,
        },
      },
    });

    return dispatch(addModal({ id: MODAL_ID, isHigherThanAll: true }));
  };

export default togglePostAssetFullscreenModal;
